"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.createDeviceSocket = exports.warnings = void 0;
var logs_1 = require("@ledgerhq/logs");
var isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
var rxjs_1 = require("rxjs");
var errors_1 = require("@ledgerhq/errors");
var deviceAccess_1 = require("../hw/deviceAccess");
var env_1 = require("../env");
var warningsSubject = new rxjs_1.Subject();
exports.warnings = warningsSubject.asObservable();
var ALLOW_MANAGER_DELAY = 500;
/**
 * use Ledger WebSocket API to exchange data with the device
 * Returns an Observable of the final result
 */
var createDeviceSocket = function (transport, _a) {
    var url = _a.url, unresponsiveExpectedDuringBulk = _a.unresponsiveExpectedDuringBulk;
    return new rxjs_1.Observable(function (o) {
        var deviceError = null; // the socket was interrupted by device problem
        var unsubscribed = false; // subscriber wants to stops everything
        var correctlyFinished = false; // the socket logic reach a normal termination
        var inBulk = false; // bulk is a mode where we have many apdu to run on device and no longer need the connection
        var timeoutForAllowManager = null; // track if there is an ongoing allow manager step
        var ws = new isomorphic_ws_1["default"](url);
        ws.onopen = function () {
            (0, logs_1.log)("socket-opened", url);
            o.next({
                type: "opened"
            });
        };
        ws.onerror = function (e) {
            (0, logs_1.log)("socket-error", e.message);
            if (inBulk)
                return; // in bulk case, we ignore any network events because we just need to unroll APDUs with the device
            o.error(new errors_1.WebsocketConnectionError(e.message, {
                url: url
            }));
        };
        ws.onclose = function () {
            (0, logs_1.log)("socket-close");
            if (inBulk)
                return; // in bulk case, we ignore any network events because we just need to unroll APDUs with the device
            if (correctlyFinished) {
                o.complete();
            }
            else {
                o.error(new errors_1.WebsocketConnectionError("closed"));
            }
        };
        ws.onmessage = function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var input, _a, nonce, apdu, allowManagerAwaitingUser_1, r, status_1, data, msg, strMsg, data_1, notify, i, r, status_2, payload, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (unsubscribed)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 14, , 15]);
                        input = JSON.parse(e.data);
                        (0, logs_1.log)("socket-in", input.query, input);
                        _a = input.query;
                        switch (_a) {
                            case "exchange": return [3 /*break*/, 2];
                            case "bulk": return [3 /*break*/, 4];
                            case "success": return [3 /*break*/, 9];
                            case "error": return [3 /*break*/, 10];
                            case "warning": return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 12];
                    case 2:
                        nonce = input.nonce;
                        apdu = Buffer.from(input.data, "hex");
                        o.next({
                            type: "exchange-before",
                            nonce: nonce,
                            apdu: apdu
                        });
                        allowManagerAwaitingUser_1 = false;
                        if (apdu.slice(0, 2).toString("hex") === "e051") {
                            timeoutForAllowManager = setTimeout(function () {
                                if (unsubscribed)
                                    return;
                                allowManagerAwaitingUser_1 = true;
                                o.next({
                                    type: "device-permission-requested",
                                    wording: "Ledger Manager"
                                });
                            }, ALLOW_MANAGER_DELAY);
                        }
                        return [4 /*yield*/, transport.exchange(apdu)];
                    case 3:
                        r = _b.sent();
                        if (timeoutForAllowManager) {
                            // if the exchange is faster than the timeout, we pass through because it's not "awaiting" user action
                            clearTimeout(timeoutForAllowManager);
                            timeoutForAllowManager = null;
                        }
                        if (unsubscribed)
                            return [2 /*return*/];
                        status_1 = r.readUInt16BE(r.length - 2);
                        // Pushes an error on locked device. TransportStatusError will
                        // be remapped to a LockedDeviceError with a correct error message.
                        if (status_1 === errors_1.StatusCodes.LOCKED_DEVICE) {
                            o.error(new errors_1.TransportStatusError(status_1));
                            return [2 /*return*/];
                        }
                        // if allow manager was requested, we either throw if deny or emit accepted
                        if (allowManagerAwaitingUser_1) {
                            if (status_1 === 0x6985 || status_1 === 0x5501) {
                                o.error(new errors_1.UserRefusedAllowManager());
                                return [2 /*return*/];
                            }
                            o.next({
                                type: "device-permission-granted"
                            });
                        }
                        data = r.slice(0, r.length - 2);
                        o.next({
                            type: "exchange",
                            nonce: nonce,
                            apdu: apdu,
                            status: status_1,
                            data: data
                        });
                        msg = {
                            nonce: nonce,
                            response: status_1 === 0x9000 ? "success" : "error",
                            data: data.toString("hex")
                        };
                        (0, logs_1.log)("socket-out", msg.response);
                        strMsg = JSON.stringify(msg);
                        ws.send(strMsg);
                        return [3 /*break*/, 13];
                    case 4:
                        // in bulk, we just have to unroll a lot of apdus, we no longer need the WS
                        inBulk = true;
                        ws.close();
                        data_1 = input.data;
                        notify = function (index) {
                            return o.next({
                                type: "bulk-progress",
                                progress: index / data_1.length,
                                index: index,
                                total: data_1.length
                            });
                        };
                        notify(0);
                        i = 0;
                        _b.label = 5;
                    case 5:
                        if (!(i < data_1.length)) return [3 /*break*/, 8];
                        return [4 /*yield*/, transport.exchange(Buffer.from(data_1[i], "hex"))];
                    case 6:
                        r = _b.sent();
                        if (unsubscribed)
                            return [2 /*return*/];
                        status_2 = r.readUInt16BE(r.length - 2);
                        // any non success intermediary status will interrupt everything
                        if (status_2 !== 0x9000)
                            throw new errors_1.TransportStatusError(status_2);
                        notify(i + 1);
                        _b.label = 7;
                    case 7:
                        i++;
                        return [3 /*break*/, 5];
                    case 8:
                        correctlyFinished = true;
                        o.complete();
                        return [3 /*break*/, 13];
                    case 9:
                        {
                            payload = input.result || input.data;
                            if (payload)
                                o.next({
                                    type: "result",
                                    payload: payload
                                });
                            correctlyFinished = true;
                            o.complete();
                            return [3 /*break*/, 13];
                        }
                        _b.label = 10;
                    case 10:
                        {
                            // an error from HSM
                            throw new errors_1.DeviceSocketFail(input.data, {
                                url: url
                            });
                        }
                        _b.label = 11;
                    case 11:
                        {
                            // a warning from HSM
                            o.next({
                                type: "warning",
                                message: input.data
                            });
                            warningsSubject.next(input.data);
                            return [3 /*break*/, 13];
                        }
                        _b.label = 12;
                    case 12:
                        console.warn("Cannot handle msg of type ".concat(input.query), {
                            query: input.query,
                            url: url
                        });
                        _b.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        err_1 = _b.sent();
                        deviceError = err_1;
                        (0, logs_1.log)("socket-message-error", err_1.message);
                        o.error(err_1);
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        }); };
        var onDisconnect = function (e) {
            transport.off("disconnect", onDisconnect);
            var error = new errors_1.DisconnectedDeviceDuringOperation((e && e.message) || "");
            deviceError = error;
            o.error(error);
        };
        var onUnresponsiveDevice = function () {
            if (inBulk && unresponsiveExpectedDuringBulk)
                return; // firmware identifier is blocking in bulk
            if (timeoutForAllowManager)
                return; // allow manager is not a locked case
            if (unsubscribed)
                return;
            o.error(new errors_1.ManagerDeviceLockedError());
        };
        transport.on("disconnect", onDisconnect);
        transport.on("unresponsive", onUnresponsiveDevice);
        return function () {
            unsubscribed = true;
            transport.off("disconnect", onDisconnect);
            transport.off("unresponsive", onUnresponsiveDevice);
            if (!correctlyFinished && !deviceError && inBulk) {
                // if it was not normally ended, we might have to flush it
                if ((0, env_1.getEnv)("DEVICE_CANCEL_APDU_FLUSH_MECHANISM")) {
                    (0, deviceAccess_1.cancelDeviceAction)(transport);
                }
            }
            if (ws.readyState === 1) {
                // connection still active. we close it from client (e.g. user unsubscribe)
                ws.close();
            }
        };
    });
};
exports.createDeviceSocket = createDeviceSocket;
//# sourceMappingURL=socket.js.map